import React, { createContext, useContext, useState, ReactNode } from "react";

export interface User {
  id?: string;
  phonenumber: string;
  email: string;
  promotionalEmails?: boolean;
  promotionalTexts?: boolean;
  name?: string;
}

interface tempUserContextType {
  tempUser: User | null;
  settempUser: React.Dispatch<React.SetStateAction<User | null>>;
}

const tempUserContext = createContext<tempUserContextType | undefined>(
  undefined,
);

interface TempUserProviderProps {
  children: ReactNode;
}

export const TempUserProvider: React.FC<TempUserProviderProps> = ({
  children,
}) => {
  const [tempUser, settempUser] = useState<User | null>(null);

  return (
    <tempUserContext.Provider value={{ tempUser, settempUser }}>
      {children}
    </tempUserContext.Provider>
  );
};

// Custom hook
export const UsetempUser = (): tempUserContextType => {
  const context = useContext(tempUserContext);
  if (!context) {
    throw new Error("usetempUser must be used within an tempUserProvider");
  }
  return context;
};
